import { lazy } from "react"

export const AdminLogin = lazy(() => import("./login"))
export const AdminDashboard = lazy(() => import("./dashboard"))
export const AdminNotFound = lazy(() => import("./not-found"))
export const AdminRestaurantList = lazy(() => import("./restaurant-list"))
export const AdminRestaurantLayout = lazy(() => import("./restaurant-layout"))
export const AdminRestaurantInfo = lazy(() => import("./restaurant-info"))
export const AdminRestaurantSales = lazy(() => import("./restaurant-sales"))
export const AdminRestaurantTickets = lazy(() => import("./restaurant-tickets"))
export const AdminRestaurantTicketDetail = lazy(() => import("./restaurant-ticket-detail"))
export const AdminRestaurantSalesFee = lazy(() => import("./restaurant-sales-fee"))
export const AdminPurchaseList = lazy(() => import("./purchase-list"))
export const AdminPurchaseDetail = lazy(() => import("./purchase-detail"))
export const AdminSettingsLayout = lazy(() => import("./settings-layout"))
export const AdminSettingMembers = lazy(() => import("./setting-members"))
export const AdminSettingMemberDetail = lazy(() => import("./setting-member-detail"))
export const AdminSettingMemberNew = lazy(() => import("./setting-member-new"))
export const AdminSettingTerms = lazy(() => import("./setting-terms"))
